import React, {useState} from 'react';
import {ContingentBeneficiaryList} from 'ApplicationEntry/models/ContingentBeneficiaryList';
import {
  MenuItem,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@material-ui/core';
import ActionsMenu from 'Shared/components/PagedView/ActionsMenu';
import {maskTaxId} from 'Shared/utilities/taxIdMasker';
import {maskPhoneNumber} from 'Shared/utilities/phoneNumberMasker';
import {updateContingentBeneficiaryValues} from 'ApplicationEntry/ducks/contingentBeneficiary';
import {useDispatch} from 'react-redux';
import ContingentBeneficiaryDialog from './ContingentBeneficiaryDialog';
import {removeContingentBeneficiary} from 'ApplicationEntry/ducks/contingentBeneficiaryList';
import './ContingentBeneficiary.sass';
import {ContingentBeneficiary} from 'ApplicationEntry/models/ContingentBeneficiary';
import DateUtility from 'Shared/utilities/DateUtility';
import {ApplicationModeType} from 'ApplicationEntry/models/ApplicationModeType';
import {maskZipCode} from 'ApplicationEntry/models/ZipCode';

type TabularProps = {
  contingentBeneficiaryItem: ContingentBeneficiaryList;
  mode: ApplicationModeType;
};

export default function PrimaryBeneficiaryTabularList(props: TabularProps) {
  const dispatch = useDispatch();

  const [openDeleteBox, setOpenDeleteBox] = useState(false);
  const [Index, setIndex] = useState(0);
  const [openEditBox, setOpenEditBox] = useState(false);

  const handleClickOpen = (index: number) => {
    setOpenDeleteBox(true);
    setIndex(index);
  };

  const handleEditContingentBeneficiary = (index: number) => {
    setIndex(index);
    const contingentBeneficiaryItems = props.contingentBeneficiaryItem.contingentBeneficiaryList.get(
      index
    ) as ContingentBeneficiary;

    dispatch(
      updateContingentBeneficiaryValues(
        contingentBeneficiaryItems.firstName,
        contingentBeneficiaryItems.middleName,
        contingentBeneficiaryItems.lastName,
        contingentBeneficiaryItems.relationship,
        contingentBeneficiaryItems.percent,
        maskTaxId(contingentBeneficiaryItems.socialSecurityNumber.value),
        contingentBeneficiaryItems.dob,
        contingentBeneficiaryItems.phone,
        contingentBeneficiaryItems.address,
        contingentBeneficiaryItems.addressLine2,
        contingentBeneficiaryItems.city,
        contingentBeneficiaryItems.state,
        contingentBeneficiaryItems.zip,
        contingentBeneficiaryItems.occSmokerCode,
        contingentBeneficiaryItems.signatureDate,
      )
    );
    setOpenEditBox(true);
  };

  const handleClose = () => {
    setOpenDeleteBox(false);
    setOpenEditBox(false);
  };

  const isQuality = props.mode === ApplicationModeType.Quality;

  return (
    <>
      <TableContainer component={Paper}>
        <Table className="contingent-beneficiary-section__table">
          <TableHead>
            <TableRow>
              <TableCell>First Name</TableCell>
              <TableCell>Middle Name</TableCell>
              <TableCell>Last Name</TableCell>
              <TableCell>Percent</TableCell>
              <TableCell>SSN</TableCell>
              <TableCell>Relationship</TableCell>
              <TableCell>Address</TableCell>
              <TableCell>Address Line 2</TableCell>
              <TableCell>City</TableCell>
              <TableCell>State</TableCell>
              <TableCell>Zip</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>DOB</TableCell>
              {!isQuality ? <TableCell>Actions</TableCell> : null}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.contingentBeneficiaryItem.contingentBeneficiaryList.map((item, index) => {
              return (
                <TableRow key={index}>
                  <TableCell component="th" scope="row">
                    {item.firstName.value}
                  </TableCell>
                  <TableCell>{item.middleName.value}</TableCell>
                  <TableCell>{item.lastName.value}</TableCell>
                  <TableCell>{item.percent}%</TableCell>
                  <TableCell>{maskTaxId(item.socialSecurityNumber.value)}</TableCell>
                  <TableCell>{item.relationship.value}</TableCell>
                  <TableCell>{item.address.value}</TableCell>
                  <TableCell>{item.addressLine2.value}</TableCell>
                  <TableCell>{item.city.value}</TableCell>
                  <TableCell>{item.state.value}</TableCell>
                  <TableCell>{maskZipCode(item.zip.value)}</TableCell>
                  <TableCell>{maskPhoneNumber(item.phone.phoneNumber)}</TableCell>
                  <TableCell>{DateUtility.toFormattedDate(item.dob)}</TableCell>
                  {
                    <TableCell>
                      <ActionsMenu>
                        <MenuItem
                          key="contingent-beneficiary-edit"
                          onClick={event => handleEditContingentBeneficiary(index)}
                        >
                          Edit
                        </MenuItem>
                        <MenuItem key="contingent-beneficiary-delete" onClick={() => handleClickOpen(index)}>
                          Delete
                        </MenuItem>
                      </ActionsMenu>
                    </TableCell>
                  }
                </TableRow>
              );
            })}
            <TableRow>
              <TableCell className="contingent-beneficiary-section__table-total-count">Item Count:</TableCell>
              <TableCell className="contingent-beneficiary-section__table-total-count">
                {props.contingentBeneficiaryItem.contingentBeneficiaryList.size}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {props.contingentBeneficiaryItem.contingentBeneficiaryList.size > 0 ? (
        <Dialog
          open={openDeleteBox}
          keepMounted
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary" style={{color: 'red'}}>
            Delete Contingent Beneficiary
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Contingent Beneficiary will be removed from the list. Do you want to delete{' '}
              <span style={{fontWeight: 'bold'}}>
                {props.contingentBeneficiaryItem.contingentBeneficiaryList.toArray()[Index].firstName.value}{' '}
                {props.contingentBeneficiaryItem.contingentBeneficiaryList.toArray()[Index].lastName.value}?
              </span>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => {
                setOpenDeleteBox(false);
                setIndex(0);
                dispatch(removeContingentBeneficiary(Index));
              }}
              color="primary"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
      <ContingentBeneficiaryDialog
        dialogOpen={openEditBox}
        dialogClose={handleClose}
        dialogTitle="Add Contingent Beneficiaries"
        dialogSubTitle="Beneficiary Information"
        dialogAdditional="ADDITIONAL BENEFICIARY"
        contingentBeneficiaryIndex={Index}
        editContingentBeneficiary={openEditBox}
      />
    </>
  );
}
